"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cube = void 0;

var _reactIcons = require("react-icons");

var CubeJson = {
  tag: "svg",
  attr: {
    viewBox: "0 0 32 32"
  },
  child: [{
    tag: "path",
    attr: {
      d: "M14.9467 0.188689L1.94413 4.99429C0.775151 5.42556 0 6.53455 0 7.76676V21.6352C0 22.7565 0.643876 23.7793 1.65657 24.2783L14.6591 30.6858C15.503 31.1047 16.497 31.1047 17.3409 30.6858L30.3434 24.2783C31.3624 23.7793 32 22.7504 32 21.6352V7.76676C32 6.53455 31.2248 5.43173 30.0559 5.00045L17.0533 0.19485C16.3782 -0.0639137 15.6281 -0.0639137 14.9467 0.188689ZM16.0031 1.90762L30.0059 7.08288V7.10136L16.0031 13.0837L2.00039 7.10136V7.08288L16.0031 1.90762ZM2.00039 9.25156L15.0029 14.8027V28.6465L2.00039 22.239V9.25156ZM17.0033 28.6465V14.8027L30.0059 9.25156V22.2452L17.0033 28.6465Z"
    },
    child: []
  }]
};

var Cube = function Cube(props) {
  return (0, _reactIcons.GenIcon)(CubeJson)(props);
};

exports.Cube = Cube;